import { useParams } from "react-router";
import { useRltOfferShowQuery } from "@/services/backend/rlt/offers/api/offer-api";
import { TreatmentComponent } from "@/services/backend/rlt/treatments/components/treatment-component";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Column } from "@/services/backend/rlt/treatments/lib/treatment-component-state";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import t from "@/lang/lang";
import { TreatmentRemark } from "@/services/backend/rlt/treatments/components/treatment-remark";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function OfferTreatmentRoute() {
  const { offerId } = useParams();
  const {
    data: offer,
    isLoading,
    error,
  } = useRltOfferShowQuery({ id: offerId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <TreatmentComponent
        treatmentId={offer!.treatmentId}
        disabled={isImmutable(offer!)}
        availableColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.ComponentData,
          Column.Cycle,
          Column.Formula,
          Column.CleanTime,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.SpecialDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
        defaultColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.ComponentData,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
      />
      <TreatmentRemark
        treatmentId={offer!.treatmentId}
        disabled={isImmutable(offer!)}
      />
      <Textblocks
        subdomain={GSMSubdomain.RLT}
        documentKind={GSMDocumentKind.Treatment}
        documentId={offer!.treatmentId}
        title={t("Allgemeine Bemerkungen im Leistungsverzeichnis")}
        defaultOpen={false}
      />
    </div>
  );
}
